import FoodCategory from "@/masters/foodCategory/FoodCategory";
import { apiService } from "@/services/api/apiService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;
interface foodCategory {
    foodCategoryName: string,
    id: number,
}
interface categoryState {
    data: foodCategory[],
    loadinng: boolean,
    error: string | null

}
interface ApiResponse {
    data: foodCategory[];
}

export const fetchFoodCategory = createAsyncThunk<foodCategory[]>(
    'foodCategory/fetchFoodCategroy',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.get<ApiResponse>('/get_all_food_category', PORT, MASTERURL)
            return response.data
        }
        catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');

        }
    }
)

export const updateFoodCategory = createAsyncThunk(
    'FoodCategory/updateFoodCategory',
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await apiService.put<ApiResponse>('update_food_category', payload, PORT, MASTERURL)
            return response.data;
        }
        catch (error) {
            return rejectWithValue(
                error instanceof Error ? error.message : 'An error occurred'
            );

        }
    }
)

export const createFoodCategory = createAsyncThunk(
    'FoodCategory/updateFoodCategory',
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await apiService.post<ApiResponse>('create_food_category', payload, PORT, MASTERURL)
            return response.data
        }
        catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred')

        }
    }
)

export const softDeleteFoodCategory: any = createAsyncThunk<
    number,
    number
>(
    "FoodCategory/softDeleteFoodCategory",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `soft_delete_food_category?id=${id}`,
                {},
                PORT,
                MASTERURL
            );
            return response



        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting cuisine type"
            );
        }
    }
);

export const foodCategorySlice = createSlice({
    name: 'foodCategory',
    initialState: {
        data: [] as foodCategory[],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFoodCategory.pending, (state) => {
                state.loading = true,
                    state.error = null
            })
            .addCase(fetchFoodCategory.fulfilled, (state, action) => {
                state.loading = false,
                    state.data = action.payload
            })


    }

})

export default foodCategorySlice.reducer;